(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 8105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(4110);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8172);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Container_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Container_module_sass__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
Container.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any)
};


/***/ }),

/***/ 5137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Container_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7158);
/* harmony import */ var _SearchInput_SearchInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4837);
/* harmony import */ var _Header_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7342);
/* harmony import */ var _Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Header_module_sass__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable @next/next/no-img-element */ 





var Header = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var headerClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().header), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().headerOpen) : "");
    var menuClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menu), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menuOpen) : "");
    var burgerClass = "".concat((_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().burgerIcon), " ").concat(isMenuOpen ? (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().open) : "");
    var closeMenu = function() {
        return setIsMenuOpen(false);
    };
    var toggleMenu = function(e) {
        e.preventDefault();
        setIsMenuOpen(function(isOpen) {
            return !isOpen;
        });
    };
    var menuItems = [
        {
            href: "/diary",
            title: "Cake Diary"
        },
        {
            href: "/issues",
            title: "Issues"
        },
        {
            href: "https://vimeo.com/user10253399",
            isExternal: true,
            title: "Cake TV"
        },
        {
            href: "/buy",
            isExternal: true,
            title: "Buy Print + Digital!"
        },
        {
            href: "/merch",
            isExternal: true,
            title: "Merch"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: headerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().logo),
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        onClick: closeMenu,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: "Cake Magazine"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                    className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().menuBar),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: burgerClass,
                            onClick: toggleMenu,
                            children: [
                                "Menu",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: menuClass,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    menuItems.map(function(param) {
                                        var href = param.href, isExternal = param.isExternal, title = param.title;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: isExternal ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: href,
                                                onClick: closeMenu,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: title
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: href,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    onClick: closeMenu,
                                                    children: title
                                                })
                                            })
                                        }, href);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().institutionalLinks),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/about",
                                                children: "About us"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/contact",
                                                children: "Contact"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/cookie-policy",
                                                children: "Cookie Policy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().search),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchInput_SearchInput__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        className: (_Header_module_sass__WEBPACK_IMPORTED_MODULE_5___default().socialIcons),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Instagram",
                                                href: "https://www.instagram.com/cakemagazine",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow @cakemagazine on Instagram",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/instagram.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Facebook",
                                                href: "https://www.fb.com/cakemag",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Facebook",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/facebook.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Vimeo",
                                                href: "https://vimeo.com/user10253399",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Vimeo",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/vimeo.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                "aria-label": "Follow Cake on Tumblr",
                                                href: "https://cake-mag.tumblr.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    alt: "Follow Cake on Tumblr",
                                                    height: 20,
                                                    width: 20,
                                                    src: "/icons/tumblr.svg"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 4837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2267);
/* harmony import */ var _SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2__);




var SearchInput = function(param) {
    var defaultValue = param.defaultValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_SearchInput_module_sass__WEBPACK_IMPORTED_MODULE_2___default().searchContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            action: "/search",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    autoCapitalize: "off",
                    autoComplete: "off",
                    defaultValue: defaultValue,
                    name: "q",
                    placeholder: "Search",
                    required: true,
                    type: "search"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "submit",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "Search",
                        height: 20,
                        width: 20,
                        src: "/icons/search.svg"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchInput);
SearchInput.propTypes = {
    defaultValue: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};


/***/ }),

/***/ 4110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(414);
// EXTERNAL MODULE: ./components/ContactForm/ContactForm.module.sass
var ContactForm_module = __webpack_require__(1443);
var ContactForm_module_default = /*#__PURE__*/__webpack_require__.n(ContactForm_module);
;// CONCATENATED MODULE: ./components/ContactForm/ContactForm.js





var FORM_URI = "https://api.cake-mag.com/wp-json/contact-form-7/v1/contact-forms/35125/feedback";
var ContactForm = function() {
    var formRef = (0,react.useRef)();
    var ref = (0,react.useState)(), status = ref[0], setStatus = ref[1];
    var handleOnSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var body, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        body = new FormData(e.target);
                        return [
                            4,
                            fetch(FORM_URI, {
                                body: body,
                                method: "POST"
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        setStatus(data.ok ? "success" : "error");
                        if (data.ok) {
                            formRef.current.reset();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ContactForm_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Get in touch with us through the contact form below or send an e-mail to",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:hello@cake-mag.com",
                        children: "hello@cake-mag.com"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (ContactForm_module_default()).form,
                method: "post",
                onSubmit: handleOnSubmit,
                ref: formRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Your name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                "aria-invalid": "false",
                                "aria-required": "true",
                                name: "from-name",
                                required: true,
                                size: "40",
                                type: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Your email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                "aria-invalid": "false",
                                "aria-required": "true",
                                name: "email",
                                required: true,
                                size: "40",
                                type: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Subject"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                name: "subject",
                                "aria-required": "true",
                                "aria-invalid": "false",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "Submissions",
                                        children: "Submissions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "Suggestions/Feedback",
                                        children: "Suggestions/Feedback"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "Report a bug",
                                        children: "Report a bug"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "Other",
                                        children: "Other"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Your message"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                name: "message",
                                cols: "40",
                                required: true,
                                rows: "10",
                                "aria-invalid": "false"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "submit",
                            children: "Send"
                        })
                    }),
                    status === "error" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "An error occurred, try again later."
                    }),
                    status === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Your message has been successfully sent!"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ContactForm_ContactForm = (ContactForm);

// EXTERNAL MODULE: ./components/Container/Container.js
var Container = __webpack_require__(7158);
// EXTERNAL MODULE: ./components/Header/Header.js
var Header = __webpack_require__(5137);
// EXTERNAL MODULE: ./styles/Home.module.sass
var Home_module = __webpack_require__(3200);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./pages/contact.js







function ContactPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "contact | cake-mag.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Get in touch with us"
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Get in touch with us"
                    }, "ogDescription")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Say hello"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm_ContactForm, {})
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 1443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactForm_wrapper__MnA0i","form":"ContactForm_form__D6xVU"};

/***/ }),

/***/ 8172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__jvqQM"};

/***/ }),

/***/ 7342:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__c7sEG","headerOpen":"Header_headerOpen__1eT1g","shadow":"Header_shadow__vX_rV","burgerIcon":"Header_burgerIcon__bMu2L","open":"Header_open__5zsqk","menu":"Header_menu__oC7Qi","menuOpen":"Header_menuOpen__xsvrr","search":"Header_search__D2K1q","institutionalLinks":"Header_institutionalLinks__aqwUq","socialIcons":"Header_socialIcons__GHhSJ"};

/***/ }),

/***/ 2267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchInput_searchContainer__KqjXj"};

/***/ }),

/***/ 3200:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__zBkib"};

/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(8105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);